/*
  Entur Swiss, Redesign v4: kleines Verhalten für die es-Sections.
  Tabs, Produkt-Slider, Mengenauswahl, Filter, Galerie, Formular-Tracking.
*/
(function () {
  'use strict';

  /* Tabs: [data-es-tabs] mit [data-es-tab="x"] und [data-es-panel="x"] */
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-es-tab]');
    if (!tab) return;
    var root = tab.closest('[data-es-tabs]');
    if (!root) return;
    var id = tab.getAttribute('data-es-tab');

    root.querySelectorAll('[data-es-tab]').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-es-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-es-panel') !== id;
    });

    var more = root.querySelector('[data-es-more]');
    if (more && tab.dataset.url) more.href = tab.dataset.url;

    updateSlider(root);
  });

  /* Produkt-Slider: Pfeile und Fortschrittsbalken folgen dem sichtbaren Track */
  function activeTrack(root) {
    return (
      root.querySelector('[data-es-panel]:not([hidden]) [data-es-track]') ||
      root.querySelector('[data-es-track]')
    );
  }

  function updateSlider(root) {
    if (!root.matches('[data-es-slider]')) return;
    var track = activeTrack(root);
    var bar = root.querySelector('[data-es-progress]');
    var prev = root.querySelector('[data-es-prev]');
    var next = root.querySelector('[data-es-next]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    if (bar) {
      var share = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      bar.style.width = Math.min(100, share * 100) + '%';
      bar.style.left = max > 0 ? (track.scrollLeft / track.scrollWidth) * 100 + '%' : '0%';
    }
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
    root.classList.toggle('es-slider--static', max <= 2);
  }

  function initSliders() {
    document.querySelectorAll('[data-es-slider]').forEach(function (root) {
      if (root.dataset.esReady) return;
      root.dataset.esReady = '1';
      root.querySelectorAll('[data-es-track]').forEach(function (track) {
        track.addEventListener('scroll', function () {
          updateSlider(root);
        }, { passive: true });
      });
      var step = function (dir) {
        var track = activeTrack(root);
        if (track) track.scrollBy({ left: dir * track.clientWidth * 0.75, behavior: 'smooth' });
      };
      var prev = root.querySelector('[data-es-prev]');
      var next = root.querySelector('[data-es-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      updateSlider(root);
    });
  }

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-es-slider]').forEach(updateSlider);
  });

  /*
    Dropdown im Header: öffnet per Hover bzw. Tastatur-Fokus (CSS).
    Auf Touch-Geräten öffnet der erste Tipp das Menü, der zweite folgt dem Link.
    Escape und Klick ausserhalb schliessen es.
  */
  var noHover = window.matchMedia('(hover: none)');

  function setDropdown(item, open) {
    item.classList.toggle('is-open', open);
    var link = item.querySelector(':scope > a');
    if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-es-dropdown] > a');
    document.querySelectorAll('[data-es-dropdown].is-open').forEach(function (item) {
      if (!link || item !== link.parentElement) setDropdown(item, false);
    });
    if (!link || !noHover.matches) return;
    var item = link.parentElement;
    if (!item.classList.contains('is-open')) {
      event.preventDefault();
      setDropdown(item, true);
    }
  });

  document.addEventListener('mouseover', function (event) {
    var item = event.target.closest('[data-es-dropdown]');
    if (item && !item.classList.contains('is-closed')) {
      var link = item.querySelector(':scope > a');
      if (link) link.setAttribute('aria-expanded', 'true');
    }
  });

  document.addEventListener('mouseout', function (event) {
    var item = event.target.closest('[data-es-dropdown]');
    if (item && !item.contains(event.relatedTarget) && !item.classList.contains('is-open')) {
      var link = item.querySelector(':scope > a');
      if (link) link.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var item = event.target.closest && event.target.closest('[data-es-dropdown]');
    if (!item) return;
    setDropdown(item, false);
    item.classList.add('is-closed');
    var link = item.querySelector(':scope > a');
    if (link) link.focus();
  });

  document.addEventListener('focusout', function (event) {
    var item = event.target.closest && event.target.closest('[data-es-dropdown]');
    if (item && !item.contains(event.relatedTarget)) {
      item.classList.remove('is-closed');
      setDropdown(item, false);
    }
  });

  /* Mobiles Menü: Tipp ausserhalb oder Escape schliesst es */
  document.addEventListener('click', function (event) {
    document.querySelectorAll('details.es-mnav[open]').forEach(function (nav) {
      if (!nav.contains(event.target)) nav.open = false;
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var nav = document.querySelector('details.es-mnav[open]');
    if (!nav) return;
    nav.open = false;
    nav.querySelector('summary').focus();
  });

  /* Shopseite mobil: Filter auf- und zuklappen */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-es-filter-toggle]');
    if (!toggle) return;
    var box = document.getElementById(toggle.getAttribute('aria-controls'));
    var open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (box) box.classList.toggle('is-open', open);
  });

  /* Mengenauswahl */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-es-qty-step]');
    if (!btn) return;
    var input = btn.closest('[data-es-qty]').querySelector('input');
    var step = parseInt(input.step, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var value = (parseInt(input.value, 10) || min) + step * parseInt(btn.getAttribute('data-es-qty-step'), 10);
    input.value = Math.max(min, value);
  });

  /* Galerie: Vorschaubild tauscht das Hauptbild */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-es-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-es-gallery]');
    var main = gallery.querySelector('[data-es-gallery-main] img');
    if (main) {
      main.src = thumb.getAttribute('data-es-thumb');
      main.removeAttribute('srcset');
    }
    gallery.querySelectorAll('[data-es-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  /*
    Produktseite: Das Anfrageformular ist zugeklappt. Es öffnet sich über den
    Button, über Links auf #EsAnfrage und von selbst, wenn nach dem Absenden
    ein Fehler oder die Bestätigung darin steht.
  */
  function initAnfrage() {
    var box = document.querySelector('[data-es-anfrage]');
    if (!box || box.dataset.esReady) return;
    box.dataset.esReady = '1';
    if (location.hash === '#EsAnfrage' || box.querySelector('.anfrage__error, .anfrage__success')) {
      box.open = true;
    }
    box.addEventListener('toggle', function () {
      if (!box.open) return;
      var field = box.querySelector('input:not([type="hidden"]), textarea');
      if (field) field.focus({ preventScroll: true });
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href="#EsAnfrage"]');
    var box = document.querySelector('[data-es-anfrage]');
    if (!link || !box) return;
    event.preventDefault();
    box.open = true;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /*
    Shopseite: Kategorien, Filter und Seitenwechsel laden nur Kategorie-Header
    und Produktraster neu, ohne die Seite zu verlassen. Die Produkte bleiben
    dort stehen, wo sie waren. Ohne JavaScript greifen die normalen Links
    (mit #produkte als Sprungziel).
  */
  var shopRequest = null;

  function loadShop(url, push) {
    var shop = document.getElementById('produkte');
    var target = new URL(url, location.href);
    target.hash = '';
    if (!shop) {
      location.href = target.href;
      return;
    }
    if (shopRequest) shopRequest.abort();
    shopRequest = new AbortController();
    var toggle = shop.querySelector('[data-es-filter-toggle]');
    var filterOpen = toggle && toggle.getAttribute('aria-expanded') === 'true';
    shop.classList.add('is-loading');

    fetch(target.href, { signal: shopRequest.signal })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('produkte');
        if (!next) throw new Error('Produktraster fehlt');

        var before = shop.getBoundingClientRect().top;
        var hero = document.querySelector('.es-page-hero');
        var nextHero = doc.querySelector('.es-page-hero');
        if (hero && nextHero) hero.replaceWith(nextHero);
        shop.innerHTML = next.innerHTML;
        shop.classList.remove('is-loading');
        document.title = doc.title;
        if (push) history.pushState({ esShop: true }, '', target.href);

        // Header oben kann anders hoch sein: Produkte bleiben trotzdem an ihrem Platz
        window.scrollBy(0, shop.getBoundingClientRect().top - before);
        // War man weiter unten in der Liste, sanft zum Anfang der neuen Auswahl
        var grid = shop.querySelector('.es-shop__products, .es-shop__empty');
        if (grid && grid.getBoundingClientRect().top < 0) {
          window.scrollBy({ top: grid.getBoundingClientRect().top - 24, behavior: 'smooth' });
        }

        if (filterOpen) {
          var newToggle = shop.querySelector('[data-es-filter-toggle]');
          var box = newToggle && document.getElementById(newToggle.getAttribute('aria-controls'));
          if (newToggle) newToggle.setAttribute('aria-expanded', 'true');
          if (box) box.classList.add('is-open');
        }
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        location.href = target.href;
      });
  }

  // Erfassungsphase, damit Horizons Seitenübergang den Klick nicht vorher übernimmt
  document.addEventListener('click', function (event) {
    var link = event.target.closest('#produkte a[href]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    if (link.getAttribute('href').charAt(0) === '#') return;
    var url = new URL(link.getAttribute('href'), location.href);
    if (url.origin !== location.origin || url.pathname.indexOf('/collections/') !== 0) return;
    // Produktkarten führen auf die Produktseite, die bleibt ein normaler Link
    if (url.pathname.indexOf('/products/') !== -1) return;
    event.preventDefault();
    event.stopPropagation();
    loadShop(url.href, true);
  }, true);

  window.addEventListener('popstate', function (event) {
    if (event.state && event.state.esShop) loadShop(location.href, false);
  });

  if (document.getElementById('produkte')) {
    history.replaceState({ esShop: true }, '', location.href);
  }

  /* Filter: jede Änderung lädt die Auswahl neu, Enter im Preisfeld ebenso */
  function submitFilter(form) {
    var url = new URL(form.getAttribute('action'), location.href);
    url.search = new URLSearchParams(new FormData(form)).toString();
    loadShop(url.href, true);
  }

  document.addEventListener('change', function (event) {
    var form = event.target.closest('form[data-es-filter]');
    if (!form) return;
    clearTimeout(form._esTimer);
    form._esTimer = setTimeout(function () {
      submitFilter(form);
    }, event.target.type === 'number' ? 600 : 0);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form[data-es-filter]');
    if (!form) return;
    event.preventDefault();
    clearTimeout(form._esTimer);
    submitFilter(form);
  });

  /*
    Kontaktformular: wie beim Anfrageblock E-Mail und Vorgangs-ID im
    sessionStorage ablegen. Die Dankeseite feuert damit die Conversion.
  */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form.es-contact-form')) return;
    var email = form.querySelector('input[name="contact[email]"]');
    try {
      sessionStorage.setItem('entur_anfrage', JSON.stringify({
        email: email ? email.value : '',
        produkt: 'Kontaktbereich',
        id: 'kontakt-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8),
      }));
    } catch (e) {
      /* Privater Modus: dann ohne Conversion-Daten. */
    }
  });

  /* Telefon-Klick zählt als Lead, einmal pro Seitenaufruf */
  var telGefeuert = false;
  document.addEventListener('click', function (event) {
    var tel = event.target.closest('a[data-es-tel]');
    if (!tel || telGefeuert) return;
    telGefeuert = true;
    if (typeof window.enturConversion === 'function') {
      window.enturConversion('telefon', { id: 'telefon-' + Date.now() });
    }
  });

  function init() {
    initSliders();
    initAnfrage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
